module.exports = __webpack_public_path__ + "static/media/fire.6d81e122.gif";